var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfrastuctureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "infrastucture-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17403",
    "data-name": "Ret\\xE2ngulo 17403",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7458",
    "data-name": "Caminho 7458",
    d: "M10.333,6.333V4.667A1.672,1.672,0,0,0,8.667,3h-5A1.672,1.672,0,0,0,2,4.667V16.333A1.672,1.672,0,0,0,3.667,18H17a1.672,1.672,0,0,0,1.667-1.667V8A1.672,1.672,0,0,0,17,6.333Zm-1.667,10h-5V14.667h5Zm0-3.333h-5V11.333h5Zm0-3.333h-5V8h5Zm0-3.333h-5V4.667h5Zm8.333,10H10.333V8H17ZM15.333,9.667H12v1.667h3.333Zm0,3.333H12v1.667h3.333Z",
    transform: "translate(-0.333 -0.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastuctureIcon);
export default __webpack_public_path__ + "static/media/infrastucture-icon.319af3cfdcda5ce57cfd7585339249cb.svg";
export { ForwardRef as ReactComponent };